import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, FacebookAuthProvider, OAuthProvider, deleteUser } from 'firebase/auth';

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  const firebaseConfig = {
    apiKey: config.public.firebase.apiKey,
    authDomain: config.public.firebase.authDomain,
    projectId: config.public.firebase.projectId,
    storageBucket: config.public.firebase.storageBucket,
    messagingSenderId: config.public.firebase.messagingSenderId,
    appId: config.public.firebase.appId,
  };

  if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
    console.warn('Firebase configuration incomplete. Social login will not be available.');
    return {
      provide: {
        firebase: null,
        firebaseAuth: null,
        authProviders: null,
        deleteUser: null,
      },
    };
  }

  try {
    const app = initializeApp(firebaseConfig);

    const auth = getAuth(app);

    const authProviders = {
      google: new GoogleAuthProvider(),
      facebook: new FacebookAuthProvider(),
      apple: new OAuthProvider('apple.com'),
    };

    authProviders.google.addScope('email');
    authProviders.google.addScope('profile');

    authProviders.facebook.addScope('email');

    authProviders.apple.addScope('email');
    authProviders.apple.addScope('name');

    return {
      provide: {
        firebase: app,
        firebaseAuth: auth,
        authProviders,
        deleteUser,
      },
    };
  } catch (error) {
    console.error('Failed to initialize Firebase:', error);
    return {
      provide: {
        firebase: null,
        firebaseAuth: null,
        authProviders: null,
        deleteUser: null,
      },
    };
  }
});
